{
  "shell": {
    "headline": "One inbox for Thai online sellers",
    "subheadline": "LINE OA, Facebook and Instagram chats in one place, with CRM and PromptPay billing built in",
    "stats": {
      "trialValue": "7 days free",
      "trialLabel": "No card needed",
      "promptpayValue": "PromptPay",
      "promptpayLabel": "Easy payments",
      "uptimeValue": "99%",
      "uptimeLabel": "uptime"
    }
  },
  "login": {
    "title": "Welcome back",
    "subtitle": "Sign in to Sight Order to manage your shop's chats",
    "rememberMe": "Keep me signed in for 30 days",
    "divider": "or",
    "forgotPassword": "Forgot password?",
    "noAccount": "Don't have an account?",
    "signUpFree": "Sign up free",
    "reasonSessionExpired": "Your session expired. Please sign in again.",
    "reasonRefreshFailed": "We couldn't renew your session. Please sign in again.",
    "reasonRemoteTab": "You signed out in another tab. Please sign in again."
  },
  "register": {
    "title": "Create an account",
    "subtitle": "7 days free · No credit card required",
    "divider": "or",
    "termsPrefix": "By signing up you agree to our",
    "termsLink": "Terms of Service",
    "termsAnd": "and",
    "privacyLink": "Privacy Policy",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in"
  },
  "forgot": {
    "title": "Forgot password",
    "subtitle": "Enter your email to get a password reset link",
    "submit": "Send reset link",
    "backToLogin": "Back to sign in",
    "sentTitle": "Check your email",
    "sentSubtitle": "If an account exists, we've sent a password reset link",
    "sentBody": "Open the email and follow the link to set a new password. It may take a moment to arrive."
  },
  "verify": {
    "title": "Verify your email",
    "subtitle": "We sent a verification link to {{email}}",
    "fallbackEmail": "your email address",
    "body": "Open the email and follow the link to verify your account, then come back to this page and choose \"I've verified\".",
    "confirmed": "I've verified",
    "resend": "Resend verification email",
    "resendSuccess": "Verification email sent again",
    "notVerifiedYet": "Not verified yet — please follow the link in the email first.",
    "signOut": "Sign out"
  },
  "consent": {
    "version": "Version {{version}}",
    "progress": " — {{current}} of {{total}}",
    "viewFullDocument": "View the full document",
    "scrollToAccept": "Scroll to the end to accept",
    "accept": "Accept",
    "saveFailed": "We couldn't save that. Please try again."
  },
  "form": {
    "emailLabel": "Email",
    "emailRequired": "Please enter your email",
    "emailInvalid": "That email isn't valid",
    "passwordLabel": "Password",
    "passwordRequired": "Please enter your password",
    "passwordTooShort": "Password must be at least 6 characters",
    "submitRegister": "Sign up with email",
    "submitLogin": "Sign in"
  },
  "google": {
    "button": "Continue with Google",
    "loading": "Signing in...",
    "popupBlocked": "Your browser blocked the popup. Please allow it and try again.",
    "unauthorizedDomain": "This domain isn't authorised for Google sign-in",
    "notEnabled": "Google sign-in isn't enabled for this account",
    "invalidTenant": "Invalid tenant ID",
    "failedWithCode": "Couldn't sign in with Google: {{code}}",
    "failed": "Couldn't sign in with Google. Please try again."
  },
  "inApp": {
    "title": "Google sign-in doesn't work inside {{app}}",
    "titleUnnamed": "Google sign-in doesn't work in this app's built-in browser",
    "body": "Open this page in Chrome or Safari to continue with Google, or use your email and password below.",
    "openBrowser": "Open in browser",
    "openChrome": "Open in Chrome",
    "manualHint": "Tap ⋯ or the share icon, then choose “Open in Safari” or “Open in browser”.",
    "copyLink": "Copy link",
    "copied": "Link copied. Paste it into Chrome or Safari.",
    "copyFailed": "Couldn't copy the link. Press and hold the address bar to copy it."
  },
  "legal": {
    "terms": "Terms & Conditions",
    "privacy": "Privacy Policy",
    "cookie": "Cookie Policy",
    "version": "Version {{version}}",
    "notFound": "The requested document was not found",
    "backHome": "Back to home",
    "close": "Close"
  },
  "profile": {
    "title": "Set up your profile",
    "joinSubtitle": "Complete your details before joining the team",
    "startSubtitle": "Complete your details to get started",
    "shopName": "Store name",
    "shopNameRequired": "Enter your store name",
    "shopNamePlaceholder": "Enter store name",
    "firstName": "First name",
    "firstNameRequired": "Enter your first name",
    "firstNamePlaceholder": "Enter first name",
    "lastName": "Last name",
    "lastNameRequired": "Enter your last name",
    "lastNamePlaceholder": "Enter last name",
    "phone": "Phone number",
    "phoneRequired": "Enter your phone number",
    "phoneInvalid": "Enter a valid phone number",
    "phonePlaceholder": "Enter phone number",
    "continue": "Continue",
    "start": "Get started",
    "createStoreFailed": "Unable to create the store",
    "saveFailed": "Unable to save your profile"
  },
  "changePassword": {
    "title": "Change password",
    "saved": "Password changed",
    "save": "Save",
    "cancel": "Cancel",
    "current": "Current password",
    "currentRequired": "Enter your current password",
    "new": "New password",
    "newRequired": "Enter a new password",
    "tooShort": "Password must be at least 6 characters",
    "confirm": "Confirm new password",
    "confirmRequired": "Confirm your new password",
    "mismatch": "Passwords do not match"
  },
  "firebase": {
    "invalidEmail": "That email isn't valid",
    "userDisabled": "This account has been suspended",
    "userNotFound": "No account found. Check the email or sign up.",
    "wrongPassword": "Incorrect email or password",
    "invalidCredential": "Incorrect email or password",
    "emailAlreadyInUse": "That email is already registered. Please sign in.",
    "weakPassword": "That password is too weak — use at least 6 characters",
    "tooManyRequests": "Too many attempts. Please try again later.",
    "operationNotAllowed": "That sign-in method isn't enabled",
    "requiresRecentLogin": "Please sign in again before changing your password",
    "networkRequestFailed": "Network problem. Please try again.",
    "generic": "Something went wrong. Please try again."
  }
}
